import { render, staticRenderFns } from "./UserBuilder.vue?vue&type=template&id=15391c1d&scoped=true"
import script from "./UserBuilder.vue?vue&type=script&lang=js"
export * from "./UserBuilder.vue?vue&type=script&lang=js"
import style0 from "./UserBuilder.vue?vue&type=style&index=0&id=15391c1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15391c1d",
  null
  
)

export default component.exports